import type { ContentType } from 'recharts/types/component/Tooltip.js'

import { T, useI18n } from '@tribeplatform/react-components/i18n'
import { Card } from '@tribeplatform/react-ui-kit/Card'

import { calculatePayloadSum } from './utils.js'

export const ApiUsageTooltip: ContentType<number, string> = ({
  active,
  payload,
  label,
}) => {
  const { formatNumber, formatDate } = useI18n()

  if (!active || !payload?.length) {
    return null
  }

  return (
    <Card className="p-1">
      <>
        <div className="text-xs text-content text-center">
          {formatDate(label, {
            year: 'numeric',
            month: 'short',
            day: 'numeric',
          })}
        </div>
        {payload.length > 1 && (
          <div className="text-xs text-content-subdued text-center">
            <T
              defaultMessage="Total: {total, number}"
              id="Admin.Billing.ApiUsageChart.Total"
              values={{
                total: calculatePayloadSum(payload),
              }}
            />
          </div>
        )}
        {payload.map(({ color, dataKey, value, name }) => (
          <div className="flex items-center space-s-1" key={dataKey}>
            <div
              style={{ backgroundColor: color }}
              className="w-2 h-2 rounded-sm"
            ></div>
            <div className="text-xs">
              <T
                defaultMessage="{client_name}: {client_usage}"
                id="Admin.Billing.ApiUsageTooltip.Item"
                values={{
                  client_name: <span style={{ color }}>{name}</span>,
                  client_usage: <span>{formatNumber(value)}</span>,
                }}
              />
            </div>
          </div>
        ))}
      </>
    </Card>
  )
}
